import { recordPath, recordRoute } from '@/shared/registry'

/** Where the SCORM module pages live. The API calls them content packages. */
export const contentPackagesPath = '/catalog/scorm-modules'
export const createContentPackagePath = `${contentPackagesPath}/new`
export const contentPackageRoute = recordRoute('catalog', 'scorm-modules')
export const editContentPackageRoute = `${contentPackageRoute}/edit`

/** A SCORM module's details page. */
export function contentPackagePath(id: string): string {
  return recordPath('catalog', 'scorm-modules', id)
}

/** The base of SCORM Module Details' slots (`detailsSlots`). */
export const contentPackageDetailsSlot = 'catalog.content-package-details'

/** The API's content package endpoints. */
export const contentPackagesApi = '/catalog/v1/content-packages'
export const contentPackageUploadLinkApi = `${contentPackagesApi}/upload-link`

export function contentPackageApi(id: string): string {
  return `${contentPackagesApi}/${encodeURIComponent(id)}`
}

/** Where a package's files are replaced with a new upload. */
export function contentPackageFilesApi(id: string): string {
  return `${contentPackageApi(id)}/package`
}

/** What each SCORM module action needs. */
export const readContentPackagesPermission = 'catalog.content-packages.read'
export const writeContentPackagesPermission = 'catalog.content-packages.write'
export const deleteContentPackagesPermission = 'catalog.content-packages.delete'

/** The largest package zip, in bytes, as the API allows. */
export const maxPackageBytes = 512 * 1024 * 1024
